<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body{
  margin: 0;
  background-color: #ffffff;
  overflow-x: hidden; 
}
.sectionBox{
  width: 1200px;
  margin:0 auto;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue